// this is an autogenerated file from DesignSystem/LeadPreview/mutation-delete-note.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_LeadPreview($note_id: uuid!) {
  delete_leads_notes_by_pk(id: $note_id) {
    id
  }
}

`